import { Box, Chip, Skeleton, styled } from '@mui/material';

export const BankFeedWrapperBox = styled(Box)<{
  hidden?: boolean;
  gapSize?: number;
}>(({ theme, hidden, gapSize = 1 }) => ({
  height: '100%',
  display: hidden === true ? 'none' : 'grid',
  gap: theme.spacing(gapSize),
  gridTemplateColumns: '1fr',
  gridTemplateRows: 'auto auto 1fr ',
}));

export const HeaderRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gridTemplateColumns: '20% 15% 20% 20%',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  alignItems: 'center',
}));

export const IconBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
}));

export const ButtonBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const ViewOptionsBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  paddingLeft: '20px',
  alignItems: 'center',
}));

export const ViewOptionChip = styled(Chip)(({ theme }) => ({
  margin: '8px',
}));

export const SkeletonBox = styled(Box)(({ theme }) => ({
  width: '100%',
  paddingRight: '2%',
}));

export const SkeletonText = styled(Skeleton)(({ theme }) => ({
  fontSize: '1rem',
}));

export const SkeletonCircular = styled(Skeleton)(({ theme }) => ({
  width: '40px',
  height: '40px',
}));

export const SkeletonRectangle = styled(Skeleton)(({ theme }) => ({
  width: '100%',
  height: '60px',
}));
